module.exports = __webpack_public_path__ + "img/66.cb3faa84.jpg";